import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'CBS Sports Network',
    callsign: 'CBSSN',
    logoUrl: networkLogos.cbssports.logoUrl,
    slug: 'cbssn',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="CBSSN"
        title="Watch CBS Sports live with Fubo"
        networkName="CBS Sports Network"
      />
    </>
  )
}
